export default "__VITE_ASSET__0379fc1f__"